import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthGuard, CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { IconModule, MediaModule } from '@spartacus/storefront';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatExpansionModule } from '@angular/material/expansion';
import { KbMyPriceListComponent } from './kb-my-price-list/kb-my-price-list.component';
import { FormsModule } from '@angular/forms';
import { KbMyAccountLeftSideNavModule } from '../my-account-left-sidenav/my-account-left-sidenav.module';
import { SecureGuard } from 'src/app/services/Guards/secure.service';



@NgModule({
    declarations: [
        KbMyPriceListComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        UrlModule,
        IconModule,
        I18nModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MediaModule,
        MatExpansionModule,
        FormsModule,
        KbMyAccountLeftSideNavModule,
        ConfigModule.withConfig({
            cmsComponents: {
                PriceListFlexComponent: {
                    component: KbMyPriceListComponent,
                    guards: [SecureGuard, AuthGuard]
                },
            }
        } as CmsConfig)
    ],
})
export class KbMyPriceListModule { }
